/* XTS Internal: This file is autogenerated by the build system. To update use codegen */
import type * as Types from '../../../../src/interfaces/xingOne';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type SelectedLanguageQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type SelectedLanguageQuery = {
  viewer?: Types.Maybe<{
    b2bProfileSettings?: Types.Maybe<
      Pick<Types.B2BProfileSettings, 'language'>
    >;
  }>;
};

export const SelectedLanguageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectedLanguage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'b2bProfileSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'language' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSelectedLanguageQuery__
 *
 * To run a query within a React component, call `useSelectedLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedLanguageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedLanguageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SelectedLanguageQuery,
    SelectedLanguageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SelectedLanguageQuery, SelectedLanguageQueryVariables>(
    SelectedLanguageDocument,
    options,
  );
}
export function useSelectedLanguageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectedLanguageQuery,
    SelectedLanguageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectedLanguageQuery,
    SelectedLanguageQueryVariables
  >(SelectedLanguageDocument, options);
}
export type SelectedLanguageQueryHookResult = ReturnType<
  typeof useSelectedLanguageQuery
>;
export type SelectedLanguageLazyQueryHookResult = ReturnType<
  typeof useSelectedLanguageLazyQuery
>;
export type SelectedLanguageQueryResult = Apollo.QueryResult<
  SelectedLanguageQuery,
  SelectedLanguageQueryVariables
>;
